import * as React from 'react'
import { Creatable } from 'react-select'
import isEmpty from 'lodash.isempty'
import Help from '../../../../../components/Help'
import { GenericInput } from '../../../../../components/Inputs'
import ConfigureOptions from '../ConfigureOptions'
import { InputLabel } from '../../../../../components/inputs/InputLabel'
import { templateStyles } from './templateStyles'

export const Form = ({ input, onFormPreviewChange, onInputChange, index }) => {
  const { props } = input
  const options = props.preserveOrder
    ? props.options || []
    : (props.options || []).slice().sort((a, b) => a.key.localeCompare(b.key))
  return (
    <div>
      <InputLabel
        title={props.label}
        required={props.required && isEmpty(props.value)}
        requiredLabelStyle={templateStyles.requiredLabel}
        requiredLabelIconName={props.requiredLabelIconName}
      >
        <Creatable
          labelKey="key"
          clearable
          // this allows users to create values with ","
          // if they enter in tab or enter, it creates the value
          shouldKeyDownEventCreateNewOption={({ keyCode }) => {
            return (
              [
                9, // tab => fix
                13 // enter => fix
              ].indexOf(keyCode) !== -1
            )
          }}
          options={options}
          onChange={e => {
            // TODO(immutablejs-removal): this component is always using onFormPreviewChange in the actual product form instead of onInputChange.
            //  I think that looks wrong, shouldn't onFormPreviewChange should probably only be used in the template editor?
            //  It looks like the only case where onInputChange would be called is when adding a new option here 🤔
            //  We should should clean this up so it's not so confusing.
            if (e === null) {
              return onFormPreviewChange(index, null)
            }
            if ((props.options || []).find(opt => opt.key === e.key)) {
              return onFormPreviewChange(index, e.value)
            }

            return onInputChange(index, {
              ...input,
              props: {
                ...input.props,
                options: [...(input.props.options || []), { value: e.value, key: e.value }],
                value: e.value
              }
            })
          }}
          value={props.value}
          placeholder={props.placeholder}
        />
      </InputLabel>
      {props.helpText && (
        <Help>
          <div>{props.helpText}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.props

  return (
    <div>
      <GenericInput title="Placeholder" value={inputProps.placeholder} onChange={v => onChange('placeholder', v)} />
      <ConfigureOptions input={input} onChange={onChange} />
    </div>
  )
}
